import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Dr. Sayuja Clinic',
    description: 'Patient records, dental visits, prescriptions and follow-up reminders for Dr. Sayuja Clinic.',
    url: getOrigin()
}
